import { DatePipe } from '@angular/common';
import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { buildRangeDateObject } from '../../helpers/buildDateObject';
import { CUSTOM_RANGE, Ui2DatePickerModel, Ui2QuickSelectOption } from '../../models/date-picker.model';

@Component({
  selector: 'ui2-datepicker-quick-options',
  templateUrl: './ui2-datepicker-quick-options.component.html',
  styleUrls: ['./ui2-datepicker-quick-options.component.scss', '../../styles/date-picker-trigger.scss']
})
export class Ui2DatepickerQuickOptionsComponent implements OnChanges {
  @Input()
  public options: Array<Ui2QuickSelectOption>;

  @Input()
  public placeholder: string;

  @Input()
  public clearable: boolean;

  @Input()
  public customClass: string = '';

  @Input()
  set datePickerModel(datePickerModel: Ui2DatePickerModel | Ui2QuickSelectOption) {
    const dateModel: Ui2DatePickerModel = datePickerModel as Ui2DatePickerModel;
    const dateOption: Ui2QuickSelectOption = datePickerModel as Ui2QuickSelectOption;

    this.selectedStartDate = dateModel?.beginJsDate;
    this.selectedEndDate = dateModel?.endJsDate;

    if (this.selectedStartDate && this.selectedEndDate) {
      this.selectedQuickSelection = this.CUSTOM_RANGE;
    } else {
      this.selectedQuickSelection = dateOption;
    }
  }

  @Output()
  dateChanged: EventEmitter<Ui2DatePickerModel | Ui2QuickSelectOption> = new EventEmitter<Ui2DatePickerModel | Ui2QuickSelectOption>();

  @Output()
  public focusChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild('picker') picker: MatDatepicker<string>;

  public selectedQuickSelection: Ui2QuickSelectOption;

  public CUSTOM_RANGE: Ui2QuickSelectOption = {
    label: CUSTOM_RANGE
  };

  public selectedStartDate: Date;
  public selectedEndDate: Date;

  public openDropdown: boolean;

  @HostListener('document:click', ['$event'])
  clickOut(event) {
    if (!this.elRef.nativeElement.contains(event.target) && this.picker && !this.picker.opened) {
      // On click outside we close the dropdown
      // we close the dropdown
      this.openDropdown = false;
    }
  }

  constructor(private readonly datePipe: DatePipe, private elRef: ElementRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    // eslint-disable-next-line no-empty
    if (changes.options) {
    }
  }

  public open() {
    this.selectedQuickSelection = this.CUSTOM_RANGE;
    this.picker.open();
  }

  public endDateUpdated() {
    if (!this.selectedEndDate) {
      return;
    }

    this.dateChanged.emit(buildRangeDateObject(this.selectedStartDate, this.selectedEndDate, this.datePipe));

    // we close the dropdown
    this.openDropdown = false;
  }

  public clear(emit: boolean = true) {
    this.selectedStartDate = null;
    this.selectedEndDate = null;

    // we clean the selected option
    this.selectedQuickSelection = null;
    // we close the dropdown
    this.openDropdown = false;

    if (emit) {
      this.dateChanged.emit(null);
    }
  }

  public selected(option: Ui2QuickSelectOption) {
    this.clear(false);

    this.selectedQuickSelection = option;

    // we close the dropdown
    this.openDropdown = false;
    this.dateChanged.emit(option);
  }

  public toggleDropdown() {
    this.focusChange.emit(true);
    this.openDropdown = !this.openDropdown;
  }
}
